// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const FAQ_FORM_USERNAME = "Login (ak si registrovan\u00e1)";
export const FAQ_FORM_WE_WILL_ANSWER_SOON = "V\u00e4\u010d\u0161inou odpoved\u00e1me do troch dn\u00ed, sna\u017e\u00edme sa v\u017edy \u010do najsk\u00f4r.";
export const FAQ_YOU_DID_NOT_ENTER_DESCRIPTION = "Nezadala si popis probl\u00e9mu";
export const HELP_FORM_ISSUE = "Popis situ\u00e1cie / probl\u00e9mu";
export const HELP_FORM_TOPIC = "T\u00e9ma";
export const HELP_FORM_WHATS_NEXT_EMAIL = "Potvrdenie o prijat\u00ed tvojej spr\u00e1vy ti po\u0161leme na tvoj email. Pr\u00edpadn\u00fa odpove\u010f rovnako.";
